module.exports = __webpack_public_path__ + "static/media/title-border-single.1b913a08.svg";